/* eslint-disable max-len */
/* istanbul ignore file */
import React from 'react';
import createSvgIcon from '@one-thd/sui-atomic-components/dist/utils/createSvgIcon';

const ProXtraIconContent = createSvgIcon(
  <>
    <mask id="a" fill="#fff">
      <rect x=".5" width="27" height="18" rx="1.44" />
    </mask>
    <rect
      x=".5"
      width="27"
      height="18"
      rx="1.44"
      stroke="#212120"
      strokeWidth="4"
      strokeLinejoin="bevel"
      mask="url(#a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.102 3.879h2.9c1.475 0 2.14.958 2.14 2.218 0 1.473-.863 2.239-2.432 2.239h-.676v2.743H4.102v-7.2Zm1.933 3.106H6.4c.488 0 .748-.272.748-.877 0-.595-.26-.878-.748-.878h-.364v1.755ZM9.86 5.466h1.921v.892h.022c.22-.674.751-1.038 1.336-1.038h.32v1.744a2.733 2.733 0 0 0-.496-.042c-.707 0-1.116.26-1.116.997v3.061H9.86V5.466ZM16.52 11.08c-2.147 0-2.34-1.306-2.34-2.885 0-1.437.274-2.875 2.34-2.875 2.146 0 2.34 1.306 2.34 2.885 0 1.438-.275 2.875-2.34 2.875Zm0-1.176c.418 0 .51-.324.51-1.701 0-1.387-.092-1.71-.51-1.71-.406 0-.508.323-.508 1.71 0 1.377.102 1.7.509 1.7ZM24.5 3.879h-1.11L22.137 6.4l-1.244-2.522h-1.168l1.797 3.54-1.94 3.66h1.111l1.393-2.713 1.365 2.713h1.171l-1.94-3.66 1.818-3.54ZM4.102 13.959h15.12v-1.44H4.102v1.44Z"
      fill="#212120"
    />
  </>,
  'ProXtra',
);

export const ProXtraIcon = () => {
  return (
    <ProXtraIconContent
      className="sui-inline-block sui-align-baseline sui-fill-none sui-w-6"
      viewBox="0 0 27 18"
    />
  );
};
